import { z } from 'zod';
import { ProductionStatus, ReleaseLevel } from '@/features/stacktrace/productions/-query/type';
import { ProductProductionTableColumns } from './-table/type';
const releaseLevelValues = Object.values(ReleaseLevel) as [ReleaseLevel, ...ReleaseLevel[]];

/**
 * プロダクト詳細 > プロダクションタブ の URL search スキーマ。
 *
 * - keyword:        バージョン（release.name）のテキスト検索
 * - releaseLevels:  レベルの複数選択フィルタ（空配列 = 全レベル）
 * - status:         ステータスの単一選択フィルタ（未指定 = 全ステータス）
 * - pageIndex:      0-origin ページ番号
 * - pageSize:       1 ページあたりの件数
 * - sortColumn:     ソート対象カラム（既定: リリース予定日）
 * - orderDirection: ソート方向（既定: 降順）
 *
 * `productId` は URL パスの `$id` が正なので search には持たない。
 * 一覧画面と違いステータスはタブではなくチップなので、既定値を置かず
 * 「絞り込みなし」から始める。
 */
export const ProductProductionTableFilterSchema = z.object({
  keyword: z.string().optional(),
  releaseLevels: z.array(z.enum(releaseLevelValues)).default([]),
  status: z.nativeEnum(ProductionStatus).optional(),
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100),
  sortColumn: z.nativeEnum(ProductProductionTableColumns).default(ProductProductionTableColumns.PLANNED_RELEASE_DATE),
  orderDirection: z.enum(['asc', 'desc']).default('desc')
});